import type { ChangeHistoryFilter } from 'v2/interfaces/productChangeHistory';

import { apiServiceProxy } from '../api-proxy';

import type { ApiServiceProxy } from '../api-proxy';

export class ProductChangeHistory {
  constructor(private readonly apiServices: ApiServiceProxy) {}

  public getChangeHistory = (productId: number, filter: ChangeHistoryFilter) => {
    return this.apiServices
      .get(`/products/${productId}/history`, { page: filter.page + 1, per_page: filter.perPage })
      .then((response) => response.data);
  };
}

const productChangeHistoryService = new ProductChangeHistory(apiServiceProxy);
export default productChangeHistoryService;
